import { useContext, memo } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';

import { guardIsRedirect } from '../../routes/interfaces';
import { getPortalRoutes } from '../../routes/portalConfig';
import { WithFilters } from '../../common/filters/withFilters';
import { ClientStatusContext } from '../../common/client-status/clientStatusContext';

import { WithPage } from './pages';
import { WithLayout } from './layout';
import { WithClientInfo } from './client-info';
import { WithClientBalance } from './client-balance';
import { WithDrawerState } from './layout/navigation/drawer';

const Portal = () => {
  const { checkIfUserHasPortalPrivilege } = useContext(ClientStatusContext);
  const { pathname } = useLocation();

  return (
    <WithClientInfo checkIfUserHasPortalPrivilege={checkIfUserHasPortalPrivilege}>
      <WithClientBalance checkIfUserHasPortalPrivilege={checkIfUserHasPortalPrivilege}>
        <WithPage currentPathname={pathname}>
          <WithDrawerState>
            <WithLayout>
              <WithFilters>
                <Switch>
                  {getPortalRoutes(checkIfUserHasPortalPrivilege).map((route, index) =>
                    guardIsRedirect(route) ? (
                      <Route key={index} render={route.render} />
                    ) : (
                      <Route key={index} path={route.path} exact={false} render={route.render} />
                    )
                  )}
                </Switch>
              </WithFilters>
            </WithLayout>
          </WithDrawerState>
        </WithPage>
      </WithClientBalance>
    </WithClientInfo>
  );
};

export default memo(Portal);
